import { CLASSIFIED_APP_NAME } from '@/constants/classifiedAppName';
import { CLASSIFIED_LOGGER_NAME } from '@/constants/classifiedLoggerName';
import { CLASSIFIED_SEARCH_PATH } from '@/constants/classifiedSearchPath';
export const appConfig = {
    technicalUrl: CLASSIFIED_SEARCH_PATH,
    loggerName: CLASSIFIED_LOGGER_NAME,
    searchEndpoints: {
        search: 'search',
        enlargement: 'search/enlargement',
        effect: 'search/effect',
    },
    countMode: 'default',
    appName: CLASSIFIED_APP_NAME,
    tracking: {
        initiative: 'wl_serp',
    },
};
